// There is a activitiesApi in @b2bportal/activities-api but it is only for checkout types atm
// rbc-activities-api includes availability, shop, autocomplete, and cancel
import { rbcActivitiesApi as defaultActivitiesApi } from "@b2bportal/rbc-activities-api";
import axios from "axios";

export const activitiesApi = defaultActivitiesApi(axios);
